  <template>
  <v-layout row class="align-center layout px-4 pt-4 app--page-header">
    <div class="page-header-left">
      <h2 class="pr-3">{{title}}</h2>
    </div>
    <v-breadcrumbs :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-spacer></v-spacer>
    <!-- <div class="page-header-right">
      <v-btn icon>
        <v-icon class="text--secondary">refresh</v-icon>
      </v-btn>
    </div> -->
  </v-layout>
</template>

<script>
import menu from '@/api/menu'
export default {
  data () {
    return {
      title: ''
    }
  },
  computed: {
    breadcrumbs: function () {
      const breadcrumbs = []
      menu.forEach(item => {
        if (item.items) {
          const child = item.items.find(i => {
            return i.component === this.$route.name
          })
          if (child) {
            breadcrumbs.push(item.title)
            breadcrumbs.push(child.title)
            this.title = child.title
          }
        } else {
          if (item.name === this.$route.name) {
            this.title = item.title
            breadcrumbs.push(item.title)
          }
        }
      })
      return breadcrumbs
    }
  }
}
</script>
